import { UPDATE_PROPERTY } from './actions'

export const getUpdatePropertyError = state => state.error.get(UPDATE_PROPERTY.ACTION)
export const getUpdatePropertyLoading = state => state.loading.get(UPDATE_PROPERTY.ACTION)
export const getFormattedAddressSelector = state => state?.property?.get('formattedAddress')
